import { IModalService } from "angular-ui-bootstrap";
import { CONTRACT_STATUSES } from "application/constants";
import { IExtraOptionPrototype } from "infrastructure/interfaces/IExtraMenuOption";
import moment from "moment";
import { CancelModal } from "application/osago/components/ugsk-osago-cancel-modal/ugsk-osago-cancel-modal";
import cancelModalTemplate from "application/osago/components/ugsk-osago-cancel-modal/ugsk-osago-cancel-modal.html";

export default {
    disabled(context): boolean {
        const contract: any = context.Contract;
        // const isFreshContract = moment() <= moment(contract.SigningDate).add(20, "day");
        const userHasPermission = context.originalEmployee.hasPermission("cancel", "Osago");
        /* const whiteList = ["ААС", "ААМ", "ТТТ", "ААН"];
        const policySerial = contract.PolicySerial; */
        const isPaid = context.getViewType() === "form" ? contract.IsPayed : contract.IsPaid;
        const statusesWhiteList = [
            CONTRACT_STATUSES.DRAFT,
            CONTRACT_STATUSES.PREPARED_FOR_SIGNING,
            CONTRACT_STATUSES.SIGNED,
        ];
        /* const hasSuitableSerial = context.getViewType() === "form"
            ? whiteList.includes(policySerial)
            : whiteList.some((serial) => contract.PolicyFullValue.indexOf(serial) >= 0); */
        const hasSuitableContractStatus = context.getViewType() === "form"
            ? statusesWhiteList.includes(contract.ContractStatusId)
            : statusesWhiteList.includes(contract.StatusId);

        if (userHasPermission && hasSuitableContractStatus && !isPaid) { // && isFreshContract && hasSuitableSerial) {
            return false;
        }
        return true;
    },
    action(context): void {
        const $uibModal = context.di<IModalService>("$uibModal");
        $uibModal
            .open({
                controller: CancelModal,
                controllerAs: "vm",
                resolve: {
                    context,
                },
                size: "lg",
                template: cancelModalTemplate,
            })
            .result.then(({ result }) => {
                (context as any).showCommonErrorsNotifications(result.response.Errors.CommonErrors);
            });
    },
    icon: "fa-times",
    title: "Отменить договор",
    tooltip: "Доступно только для договоров в статусе &#34;Оформлен&#34;/&#34;Подготовлен к продаже&#34; и &#34;Не оплачен&#34;",
} as IExtraOptionPrototype;
